import { cn } from "@/lib/utils";

interface NotificationBadgeProps {
  count: number;
  className?: string;
  showZero?: boolean;
  variant?: "default" | "dot";
}

export function NotificationBadge({
  count,
  className,
  showZero = false,
  variant = "default",
}: NotificationBadgeProps) {
  // Se não deve mostrar zero e a contagem é 0, não renderiza nada
  if (!showZero && count === 0) return null;

  // Variante "Dot" (apenas uma bolinha vermelha, sem número)
  if (variant === "dot") {
    return (
      <span className={cn("absolute right-0 top-0 flex h-3 w-3", className)}>
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-destructive opacity-75"></span>
        <span className="relative inline-flex h-3 w-3 rounded-full border-2 border-background bg-destructive"></span>
      </span>
    );
  }

  // Variante Padrão (Com número)
  return (
    <span
      className={cn(
        "absolute -right-1.5 -top-1.5 flex items-center justify-center",

        "h-5 min-w-[20px] rounded-full px-1",

        "border-2 border-background shadow-sm",

        "bg-destructive text-destructive-foreground",

        "text-[10px] font-bold tabular-nums leading-none",

        "duration-300 ease-out animate-in zoom-in-50",

        className,
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
